// @flow
import React from 'react';
import { Provider as Redux } from 'react-redux';
import configureFela from '../configureFela';
import FelaProvider from '../../common/components/FelaProvider';

// Render button as div because button is not consistently rendered across
// browsers and it's hard and tricky to enforce the same look. Making button
// from regular div is much easier.
// developer.mozilla.org/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_button_role
// developer.mozilla.org/docs/Web/Accessibility/Keyboard-navigable_JavaScript_widgets
const DivButton = (props: { disabled?: boolean, onClick?: Function, style?: Object }) => (
  <div // eslint-disable-line jsx-a11y/no-static-element-interactions
    {...props}
    role="button"
    onKeyPress={e => {
      if (props.disabled) return;
      const isSpacebar = e.key === ' ';
      if (!isSpacebar) return;
      e.preventDefault();
      if (typeof props.onClick !== 'function') return;
      props.onClick(e);
    }}
    style={{
      outline: 'none', // set outline as none by default, set it explicitely to overwrite this
      ...(props.style || null),
      pointerEvents: props.disabled ? 'none' : 'auto',
      userSelect: 'none',
    }}
    tabIndex={props.disabled ? -1 : 0}
  />
);

type BaseRootProps = {
  children: any,
  felaRenderer?: Object,
  store: Object,
};

// This is reused in src/server/frontend/render.js
const BaseRoot = ({ store, felaRenderer = configureFela(), children }: BaseRootProps) => (
  <Redux store={store}>
    <FelaProvider
      Button={props => <DivButton {...props} />}
      Image={props => <img {...props} />}
      Text={props => <span {...props} />}
      TextInput={props => <input {...props} />}
      View={props => <div {...props} />}
      renderer={felaRenderer}
    >
      {children}
    </FelaProvider>
  </Redux>
);

export default BaseRoot;
